<div class="restoreSaveButtonContainer">
  <button class="btn btn-outline-secondary form-button" type="button" (click)="restoreClicked.emit()">Restore</button>
  <button class="btn button-blue form-button" type="button" (click)="saveClicked.emit()" [disabled]="isSaveDisabled || showSpinner">{{ showSpinner ? '' : 'Save' }}
    <app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>
  </button>
</div>
